<pax-layout
  [minimal]="true"
  [acceptedLanguages]="acceptedLanguages"
  [initialLanguage]="initialLanguage"
  (changedLanguage)="setLanguage($event)"
>
  <!-- Notifications -->
  <div class="container mx-auto w-full">
    <pax-notification
      [notificationMessages]="(notificationMessages$ | async) ?? undefined"
      (delete)="deleteNotificationMessage($event)"
    ></pax-notification>
  </div>

  <!-- Display Spinner -->
  @if (backgroundSubscriptionNavigationService.isNavigationOngoing$ | async) {
    <div class="mt-12">
      <pax-spinner></pax-spinner>
    </div>
  }

  <!-- Display Content -->
  @if (
    (backgroundSubscriptionNavigationService.isNavigationOngoing$ | async) ===
    false
  ) {
    <router-outlet></router-outlet>
  }
</pax-layout>
